<template>
  <v-flex d-flex mx-1 py-1 sm-pb-0 xs12 :id="`message-${item.id}`" :justify-end="item.type == 2" :justify-start="item.type == 1">
    <v-card
      @click.left="$emit('click', $event)"
      :color="item.type == 2 ? 'primary lighten-4' : 'secondary lighten-4'"
      :class="{
        'ml-15': item.type == 2 && !$vuetify.breakpoint.xsAndDown,
        'mr-15': item.type == 1 && !$vuetify.breakpoint.xsAndDown, 
        'ml-2': item.type == 2 && $vuetify.breakpoint.xsAndDown,
        'mr-2': item.type == 1 && $vuetify.breakpoint.xsAndDown,
      }"
    >
      <v-list-item three-line>
        <v-list-item-content>
          <div class="mb-2" :class="{ 'font-weight-bold': item.viewed == 0 && item.type == 1 }">{{ item.message }}<br /><br /></div>

          <v-list-item-subtitle>
            <div class="d-flex">{{ messageDate }}<v-spacer /> {{ messageUser }}</div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-flex>
</template>

<script>
import { components } from "@/components/mixings";

export default {
  mixins: [components],
  components: {},
  props: {
    user_id: Number,
    id: Number,
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},

  computed: {
    messageUser() {
      let res = !this.item.createdby_id ? this.item.lead_name : this.item.user_name;
      return res;
    },
    messageDate() {
      const d = new Date(this.item.createdon);
      const n = new Date();
      let res = d.date == n.date ? d.shorttime : d.datetime;
      return res;
    },
  },
  watch: {},
  methods: {},
};
</script>
<style lang="scss">
@mixin table-style($color, $borderColor, $backgroundColor, $backgroundColorSelected, $backgroundColorSecond, $backgroundColorHover) {
  .comments-body {
    .comment-row {
      border-bottom: 1px solid $borderColor;
      background-color: $backgroundColor;
      &:hover {
        background: $backgroundColorHover;
      }
      &.selected {
        background-color: $backgroundColorSelected;
      }
      &.notviewed {
        font-weight: bold;
      }
    }
    .comment-row:nth-child(odd) {
      background-color: $backgroundColorSecond;
      &:hover {
        background-color: $backgroundColorHover;
      }
      &.selected {
        background-color: $backgroundColorSelected;
      }
      &.notviewed {
        font-weight: bold;
      }
    }
  }
}
.theme--dark {
  $color: #bdbdbd;
  $borderColor: #808080;
  $backgroundColor: #161616;
  $backgroundColorSelected: hsl(60, 75%, 81%);
  $backgroundColorSecond: lighten($backgroundColor, 3%);
  $backgroundColorHover: lighten($backgroundColor, 10%);
  @include table-style($color, $borderColor, $backgroundColor, $backgroundColorSelected, $backgroundColorSecond, $backgroundColorHover);
}
.theme--light {
  $color: #1a1a1a;
  $borderColor: #a3a3a3;
  $backgroundColor: #ffffff;
  $backgroundColorSelected: hsl(60, 75%, 81%);
  $backgroundColorSecond: darken($backgroundColor, 5%);
  $backgroundColorHover: darken($backgroundColor, 10%);
  @include table-style($color, $borderColor, $backgroundColor, $backgroundColorSelected, $backgroundColorSecond, $backgroundColorHover);
}
</style>
